import React from "react";
import dayjs from "dayjs";
import { Chip } from "@mui/material";
import { ScheduleOutlined } from "@mui/icons-material";

const uiMap = {
    normal: { bg: "#F3F5FF", fg: "#5751E9" },
    warning: { bg: "#FFECD6", fg: "#E4841A" },
    overdue: { bg: "#FFDEDE", fg: "#D34848" },
    completed: { bg: "#E8F5E9", fg: "#2E7D32" },
};

const formatMMSS = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, "0")}:${s
        .toString()
        .padStart(2, "0")}`;
};

export default function TatTimerChip({ row, live = true, variant = "compact" }) {
    const [, forceTick] = React.useState(0);

    // live ticking only when SLA exists
    React.useEffect(() => {
        if (!live || !row?.sla_interpretation_minutes) return;
        const i = setInterval(() => forceTick((t) => t + 1), 1000);
        return () => clearInterval(i);
    }, [live, row?.sla_interpretation_minutes]);

    // no request time
    if (!row?.interpretation_requested_at) return "--";

    const start = dayjs(Number(row.interpretation_requested_at));

    // SLA missing & NOT completed → show --
    if (
        !row?.sla_interpretation_minutes &&
        row?.interpretation_request_status !== "completed"
    ) {
        return "--";
    }


    //  COMPLETED → always show time taken
    if (
        row?.interpretation_request_status === "completed" &&
        row?.interpretation_completed_at
    ) {
        const completed = dayjs(Number(row.interpretation_completed_at));
        const takenSec = completed.diff(start, "second");

        return (
            <Chip
                size="small"
                icon={<ScheduleOutlined />}
                label={formatMMSS(takenSec)}
                sx={{
                    height: 28,
                    borderRadius: "999px",
                    fontSize: "13px",
                    fontWeight: 700,
                    backgroundColor: uiMap.completed.bg,
                    color: uiMap.completed.fg,
                }}
            />
        );
    }

    //  SLA missing → show --
    const tatMinutes = row?.sla_interpretation_minutes;
    if (!tatMinutes) return "--";

    //  IN PROGRESS / REQUESTED
    const now = live ? dayjs() : start;
    const elapsed = now.diff(start, "second");
    const total = tatMinutes * 60;
    const remaining = total - elapsed;

    //  OVERDUE
    if (remaining <= 0) {
        return (
            <Chip
                size="small"
                icon={<ScheduleOutlined />}
                label="Overdue"
                sx={{
                    height: 28,
                    borderRadius: "999px",
                    fontSize: "13px",
                    fontWeight: 700,
                    backgroundColor: uiMap.overdue.bg,
                    color: uiMap.overdue.fg,
                }}
            />
        );
    }

    const state = remaining <= 120 ? "warning" : "normal";

    return (
        <Chip
            size="small"
            icon={<ScheduleOutlined />}
            label={
                variant === "interpretation"
                    ? `Time Remaining : ${formatMMSS(remaining)}`
                    : formatMMSS(remaining)
            }
            sx={{
                height: 28,
                borderRadius: "999px",
                fontSize: "13px",
                fontWeight: 700,
                backgroundColor: uiMap[state].bg,
                color: uiMap[state].fg,
            }}
        />
    );
}
